import { useEffect, useState } from "react";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb"
import { Button } from '../../components/button'
import { DashboardWrapper } from "../../container/dashboardWrapper"
import { StyledContainer, StyledContent, StyledMainContentWrapper, StyledTopWrapper, StyledNextPageDiv, StyledNextPageDivContainer } from "../../styles/results/results"
import {
    IoDownloadOutline
} from "react-icons/io5";
import {
    MdAssessment,
    MdDoneAll,
} from "react-icons/md";
import { QuestionsStepper } from '../../components/questions-stepper'
import { resultQuestions } from '../../services/resultQuestions'

const ViewResult = () => {
    const [paginatedResults, setPaginatedResults] = useState([])
    const [currentPage, setCurrentPage] = useState(1)

    function paginate(array, page_size, page_number) {
        // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    const handleNextPage = () => {
        const newPaginatedResult = paginate(resultQuestions, 4, currentPage + 1)
        setCurrentPage(currentPage + 1)
        setPaginatedResults(newPaginatedResult)
        console.log(newPaginatedResult)
    }
    useEffect(() => {
        const paginatedFuncResult = paginate(resultQuestions, 4, currentPage)
        setPaginatedResults(paginatedFuncResult)
    }, [])

    useEffect(() => {

    }, [paginatedResults])
    return (
        <DashboardWrapper>
            <StyledTopWrapper>
                <StyledContainer>
                    <StyledContent>
                        <Breadcrumb
                            crumbs={['Results', 'English Language']}
                        />
                        <div className="top">
                            <h1 className="subject-title">English Language JSS1</h1>
                        </div>
                        <div className="bottom">
                            <h1 className="result-score">Your Score: 59/100</h1>
                        </div>
                        <div className="download-result-btn" style={{ marginTop: '3rem' }}>
                            <Button variant="secondary">download REsult <IoDownloadOutline className="download-icon" /></Button>
                        </div>
                    </StyledContent>
                </StyledContainer>
            </StyledTopWrapper>
            <StyledNextPageDiv>
                <StyledNextPageDivContainer>
                    <div className="score-icon-div">
                        <div className="check-icon-container">
                            <MdDoneAll />
                        </div>
                        <span>59/100</span>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdAssessment />
                        </div>
                        <span>JSS 1</span>
                    </div>
                    <div className="next-page-btn-div">
                        <Button onClick={handleNextPage} variant="secondary">
                            NEXT PAGE
                        </Button>
                    </div>
                </StyledNextPageDivContainer>
            </StyledNextPageDiv>
            <StyledMainContentWrapper>
                <StyledContainer>
                    <QuestionsStepper questions={paginatedResults} />
                </StyledContainer>
            </StyledMainContentWrapper>

        </DashboardWrapper >
    )
}

export default ViewResult
